import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as formatter from 'mt-react-common/utils/formatter';
import { NavLink, withRouter } from 'react-router-dom';
import { t } from 'utils/translates';
import RatingStars from '../../../../../../components/Rating/RatingStars/RatingStars';
import ListItemLink from '../../../../../../components/Common/ListItemLink/ListItemLink';

// eslint-disable-next-line react/prefer-stateless-function
class UserInfoBlock extends Component {
  componentWillUnmount() {
    // eslint-disable-next-line no-undef
    $('[data-toggle="tooltip"]').tooltip('hide');
  }

  render() {
    return (
      <React.Fragment>
        <div className="panel panel-default panel-footer_bg-sub panel-heading_padding-large">
          <div className="panel-heading text-center">
            <h1 className="panel-title">
              <div className="hidden-xs">
                <i className="fa fa-user-circle-o" />{' '}
                {formatter.emptyReplace(this.props.userInfo.username)}
              </div>
              <div className="media media_inline-table media-left_padding-xs hidden-sm hidden-md hidden-lg">
                <div className="media-left">
                  <img
                    alt=""
                    src={this.props.userInfo.avatarPath}
                    className="media-object avatar avatar-sm avatar_bordered"
                  />
                </div>
                <div className="media-body media-middle text-left">
                  <div
                    className="text-caption font-size-xxs text-caption text-success"
                    data-toggle="tooltip"
                    data-container="body"
                    data-placement="top"
                    title={`${t('Рейтинг')}: ${
                      this.props.userInfo.rating.ratingStatusPoints
                    }/${this.props.userInfo.rating.ratingStatusPointsTo} (${
                      this.props.userInfo.rating.ratingStatusTitle
                    })`}
                  >
                    <RatingStars rating={this.props.userInfo.rating.rating} />{' '}
                    {this.props.userInfo.rating.ratingStatusTitle}
                  </div>
                  <strong>{this.props.userInfo.username}</strong>
                </div>
              </div>
            </h1>
          </div>
          <div className="panel-body">
            <dl className="dl-horizontal dl-options center-block max-w-400">
              <dt>{t('Имя')}:</dt>
              <dd>
                <i className="fa fa-id-card" />{' '}
                {formatter.emptyReplace(this.props.userInfo.fullName)}
              </dd>
              <dt>{t('Рейтинг')}:</dt>
              <dd>
                <span className="text-success">
                  <span className="text-success">
                    {this.props.userInfo.rating.ratingStatusPoints}/
                    {this.props.userInfo.rating.ratingStatusPointsTo} (
                    {this.props.userInfo.rating.ratingStatusTitle})
                  </span>
                </span>
              </dd>
              <dt>{t('Дата регистрации')}:</dt>
              <dd>
                <i className="fa fa-calendar" />{' '}
                {formatter.dateFormat1(this.props.userInfo.createdAt)}
              </dd>
              <dt>{t('Дата последней активности')}:</dt>
              <dd>
                <i className="fa fa-calendar-check-o" />{' '}
                {formatter.dateFormat1(this.props.userInfo.lastAuthAt)}
              </dd>
              <dt>{t('Возраст')}:</dt>
              <dd>
                <i className="fa fa-calendar" />{' '}
                {formatter.emptyReplace(this.props.userInfo.yearsFromBirthDt)}
              </dd>
              <dt>{t('Пол')}:</dt>
              <dd>
                <i className="fa fa-female" />{' '}
                {formatter.emptyReplace(this.props.userInfo.genderLabel)}
              </dd>
              <dt>{t('Город')}:</dt>
              <dd>
                <i className="fa fa-map-marker" />{' '}
                {formatter.emptyReplace(this.props.userInfo.location.cityName)}
              </dd>
              <dt>{t('Рефер')}:</dt>
              <dd>
                {this.props.userInfo.referrer.id ? (
                  <NavLink
                    to={`/users/profile/${this.props.userInfo.referrer.id}`}
                  >
                    <i className="fa fa-user" />
                    {` ${this.props.userInfo.referrer.username}`}
                  </NavLink>
                ) : (
                  <span style={{ textTransform: 'lowercase' }}>{t('Нет')}</span>
                )}
              </dd>
            </dl>
          </div>
          <div className="panel-footer">
            <div className="hor-scroll hor-scroll_always hor-scroll_sub">
              <div className="hor-scroll-wrapper">
                <a
                  className="counter"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title={t('Выполнил заданий')}
                >
                  <div className="counter-val">
                    {
                      this.props.userInfo.countsStat.tasksStat.myExecutionsStat
                        .countExecFinished
                    }
                  </div>
                  <div className="counter-label">{t('Выполнил')}</div>
                </a>
                <NavLink
                  to={`/users/profile/${this.props.userInfo.id}/tasks`}
                  className="counter"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title={t('Создал заданий')}
                >
                  <div className="counter-val">
                    {this.props.userInfo.countsStat.tasks.count}
                  </div>
                  <div className="counter-label">{t('Заказал')}</div>
                </NavLink>
                <a
                  className="counter"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title={t('Привлек рефералов')}
                >
                  <div className="counter-val">
                    {this.props.userInfo.countsStat.referrals.count}
                  </div>
                  <div className="counter-label">{t('Рефералов')}</div>
                </a>
                <NavLink
                  to={`/users/profile/${this.props.userInfo.id}/comments-from-user`}
                  className="counter"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title={t('Прокомментаривал, оценил')}
                >
                  <div className="counter-val">
                    {this.props.userInfo.countsStat.commentsOut.total}
                  </div>
                  <div className="counter-label">{t('Отзывы')}</div>
                </NavLink>
                {/* <a
                  className="counter"
                  data-toggle="tooltip"
                  data-placement="top"
                  data-container="body"
                  title="Наруши правила"
                >
                  <div className="counter-val">?</div>
                  <div className="counter-label">Нарушения</div>
                </a> */}
              </div>
            </div>
          </div>
        </div>
        <div className="panel panel-default visible-xs visible-sm">
          <div className="panel-bar bg-main">
            <div className="hor-scroll hor-scroll_xs">
              <ul className="nav nav-tabs nav-tabs-lg hor-scroll-wrapper">
                <ListItemLink
                  to={`/users/profile/${this.props.userInfo.id}/comments`}
                >
                  {t('Отзывы о пользователе')}{' '}
                  <span className="badge">
                    {this.props.userInfo.countsStat.commentsIn.total}
                  </span>
                </ListItemLink>
                <ListItemLink
                  to={`/users/profile/${this.props.userInfo.id}/tasks`}
                >
                  {t('Задания пользователя')}{' '}
                  <span className="badge">
                    {this.props.userInfo.countsStat.tasksStat.countMyTasks}
                  </span>
                </ListItemLink>
                <ListItemLink
                  to={`/users/profile/${this.props.userInfo.id}/comments-from-user`}
                >
                  {t('Оценки, комментарии')}{' '}
                  <span className="badge">
                    {this.props.userInfo.countsStat.commentsOut.total}
                  </span>
                </ListItemLink>
              </ul>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

UserInfoBlock.propTypes = {
  userInfo: PropTypes.shape({
    id: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired,
    fullName: PropTypes.string,
    avatarPath: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    lastAuthAt: PropTypes.string.isRequired,
    birthDt: PropTypes.string,
    yearsFromBirthDt: PropTypes.number,
    genderLabel: PropTypes.string,
    rating: PropTypes.shape({
      rating: PropTypes.string.isRequired,
      ratingStatusPoints: PropTypes.number.isRequired,
      ratingStatusPointsTo: PropTypes.number.isRequired,
      ratingStatusTitle: PropTypes.string.isRequired
    }).isRequired,
    location: PropTypes.shape({
      cityName: PropTypes.string
    }).isRequired,
    countsStat: PropTypes.shape({
      tasks: PropTypes.shape({
        count: PropTypes.number.isRequired
      }).isRequired,
      tasksStat: PropTypes.shape({
        countMyTasks: PropTypes.number.isRequired,
        myExecutionsStat: PropTypes.shape({
          countExecFinished: PropTypes.number.isRequired
        })
      }),
      referrals: PropTypes.shape({
        count: PropTypes.number.isRequired
      }),
      commentsIn: PropTypes.shape({
        total: PropTypes.number.isRequired
      }).isRequired,
      commentsOut: PropTypes.shape({
        total: PropTypes.number
      })
    }).isRequired,
    referrer: PropTypes.shape({
      id: PropTypes.number,
      username: PropTypes.string
    })
  }).isRequired
};

export default withRouter(UserInfoBlock);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/UserProfile/UserInfoBlock/UserInfoBlock.js